import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import { type Shipment } from '../../domain/shipment/Shipment'
import {
  ShipmentsRepository,
  type TruckInfoPayload,
} from '../../infra/shipment/ShipmentsRepository'

type UpdateShipmentTruckInfoFactoryDependencies = {
  shipmentsRepository: ShipmentsRepository
}

export function updateShipmentTruckInfoFactory({
  shipmentsRepository,
}: UpdateShipmentTruckInfoFactoryDependencies) {
  return async function updateShipmentTruckInfo(
    params: TruckInfoPayload,
    config?: {
      signal: AbortSignal
    }
  ): Promise<Shipment> {
    return shipmentsRepository.setTruckInfo(params, config)
  }
}

export function updateShipmentTruckInfo(
  truckInfo: TruckInfoPayload,
  config?: {
    signal: AbortSignal
  }
): Promise<Shipment> {
  const httpClient = new HttpClient(API_URL)
  const shipmentsRepository = new ShipmentsRepository({ httpClient })
  const update = updateShipmentTruckInfoFactory({ shipmentsRepository })

  return update(truckInfo, config)
}
